import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { VideoEmbedComponent } from './video-embed/video-embed.component';
import { MobileAppPaymentMethodsComponent } from './public/mobile-app-payment-methods/mobile-app-payment-methods.component';
import { MobileAppPaymentCompletedComponent } from './public/mobile-app-payment-completed/mobile-app-payment-completed.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule,
      ),
  },
  {
    path: 'payments',
    redirectTo: 'rodeos/payments',
  },
  {
    path: 'organizations',
    loadChildren: () =>
      import('./organizations/organizations.module').then(
        (m) => m.OrganizationsModule,
      ),
  },
  {
    path: 'rodeos',
    loadChildren: () =>
      import('./rodeos/rodeos.module').then((m) => m.RodeosModule),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'video-embed',
    component: VideoEmbedComponent
  },
  {
    path: 'points',
    loadChildren: () => import('./points/points.module').then(m => m.PointsModule)
  },
  {
    path: 'mobile-app/add-customer-payment-method',
    component: MobileAppPaymentMethodsComponent
  },
  {
    path: 'mobile-app/completed',
    component: MobileAppPaymentCompletedComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
